const config = {
  clarityId: '86rzmgv75f',
};

export default config;
